<template>
  <div class="Endpoint" :style="{
    'padding-bottom': toggled ? '10px' : '22px'
  }">
    <div class="EndpointHeading">
      <mark class="EndpointTitle">{{ method }} {{ route }}</mark>
      <strong class="EndpointMeta">Description:</strong> <span v-html="description"></span><br>
      <strong class="EndpointMeta">Example:</strong> <mark>GET {{ example }}</mark>
    </div>

    <div class="EndpointToggle" :class="{
      'angle-down' : !toggled,
      'angle-up' : toggled
    }" @click="toggled = !toggled"></div>

    <code class="EndpointCode" v-if="toggled"><slot></slot></code>
  </div>
</template>

<script>

export default {
  props: [
    'route',
    'method',
    'description',
    'example'
  ],

  data () {
    return {
      toggled: false
    }
  }
}

</script>

<style lang="scss" scoped>

.Endpoint {
  position: relative;
  margin: 25px 20px;
  padding: 15px;
  background-color: rgba($blz-blue, .1);
  border: 1px solid rgba($blz-blue, .2);
}

.EndpointHeading {
  padding: 0 20px;
}

.EndpointTitle {
  background-color: transparent;
  border: 0;
  display: block;
  font-size: 1.4rem;
  margin-bottom: .5rem;
  padding: 0;
}

.EndpointMeta {
  display: inline-block;
  width: 100px;
}

.EndpointToggle {
  position: absolute;
  right: 45px;
  top: 15px;

  &:hover {
    cursor: pointer;
  }
}

</style>